import { useEffect } from 'react';
import { useUserStore } from 'src/store/user-store';
import { useGenerateSiteLockspaceSearchKey } from './use-generate-site-lockspace-search-key';

export const useMeilisearchLockspaceApiKey = (enabled: boolean = true) => {
  const meilisearchToken = useUserStore().meilisearchTokenLockspace;
  const setMeilisearchToken = useUserStore().setMeilisearchTokenLockspace;
  const viewContext = useUserStore().viewContext;

  const { data: newMeilisearchSiteToken } = useGenerateSiteLockspaceSearchKey(
    viewContext === 'site' && enabled,
  );

  useEffect(() => {
    if (viewContext === 'site') {
      if (
        newMeilisearchSiteToken &&
        newMeilisearchSiteToken !== meilisearchToken
      ) {
        setMeilisearchToken(newMeilisearchSiteToken);
      }
    }
  }, [
    meilisearchToken,
    newMeilisearchSiteToken,
    setMeilisearchToken,
    viewContext,
  ]);
};
